import {Injectable} from '@angular/core';
import {Cart} from '@spartacus/cart/base/root';
import {Observable, of} from 'rxjs';
import {catchError, shareReplay} from 'rxjs/operators';
import {CartDecoratorErrorHandlingService} from './cart-decorator-error-handling.service';
import {DcpGlobalMessageService} from '@dcp/configurator';

@Injectable({
  providedIn: 'root'
})
export class CheckoutErrorHandlingService {

  constructor(
    private cartDecoratorErrorHandlingService: CartDecoratorErrorHandlingService,
    private dcpGlobalMessageService: DcpGlobalMessageService
  ) {
  }

  /**
   * Catches errors with https status < 400.
   * If these errors occur the dcp-configure-service-error will be notified an opened.
   *
   * @param cart$ observable to catch the errors of
   */
  public cartRequestErrorWrapper(cart$: Observable<Cart>) {
    return cart$.pipe(
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(error => {
        this.dcpGlobalMessageService.addMessage(error, this?.constructor?.name, 'errorLogging');
        this.cartDecoratorErrorHandlingService.handle(error, null);
        return of();
      })
    );
  }
}
